import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Icon, Item, Listbox } from "@icg360/design-system";

import {
  CONTACT_PATH,
  OFFERS_PATH,
  PAPERLESS_PATH,
  PAYMENT_PATH,
  POLICIES_PATH,
  SECURITY_PATH,
} from "pages/settings/hooks";
import { logout } from "utils";

import styles from "./mobile-account-menu.module.scss";

type MobileAccountMenuProps = {
  onClose: () => void;
};

export const MobileAccountMenu = ({ onClose }: MobileAccountMenuProps) => {
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);
  const onSelectionChange = useCallback(
    (selection: Set<string>) => {
      onClose();
      const path = selection.keys().next().value;
      navigate(path);
    },
    [navigate, onClose],
  );

  const logoutOnClick = useCallback(async () => {
    setLoggingOut(true);
    logout();
  }, []);

  return (
    <div className={styles.wrapper}>
      <Listbox
        className={styles.navLinkBoxDS}
        selectionMode="single"
        onSelectionChange={onSelectionChange}
        aria-label="profile menu navigation"
      >
        <Item key={SECURITY_PATH} textValue="security">
          <div className={styles.listItem}>
            <Icon name="Lock" size="sm" />
            Security
          </div>
        </Item>
        <Item key={POLICIES_PATH} textValue="policies">
          <div className={styles.listItem}>
            <Icon name="Blueprint" size="sm" />
            Policies
          </div>
        </Item>
        <Item key={CONTACT_PATH} textValue="contact">
          <div className={styles.listItem}>
            <Icon name="Phone" size="sm" />
            Contact
          </div>
        </Item>
        <Item key={PAPERLESS_PATH} textValue="paperless">
          <div className={styles.listItem}>
            <Icon name="Paperless" size="sm" />
            Paperless
          </div>
        </Item>
        <Item key={PAYMENT_PATH} textValue="payment management">
          <div className={styles.listItem}>
            <Icon name="Billing" size="sm" />
            Payment management
          </div>
        </Item>
        <Item key={OFFERS_PATH} textValue="property services">
          <div className={styles.listItem}>
            <Icon name="Shield" size="sm" />
            Property services
          </div>
        </Item>
      </Listbox>
      <Button
        leadingIcon="Logout"
        onPress={logoutOnClick}
        loading={loggingOut}
        data-testid="mobile-logout-btn"
        fluid
      >
        Log out
      </Button>
    </div>
  );
};
